<app-leave-site-warning></app-leave-site-warning>
@if (user$ | async; as user) {
  <div class="eula-container">
    <h1 class="large-title" data-private>Welcome, {{ user.firstName }} {{ user.lastName }}!</h1>
    <h2 class="sub-title">
      Before we get this signing started, please read and accept our license agreement...
    </h2>
    @if (eulaFileContent$ | async; as eulaFileContent) {
      <div
        class="consent-box"
        [innerHTML]="eulaFileContent"
      ></div>
    }
    <app-button-container>
      <app-button type="secondary" (buttonClick)="onDecline()" [dataTestId]="'eula-decline'">
        Decline
      </app-button>
      <app-button type="primary" (buttonClick)="onAccept()" [dataTestId]="'eula-accept'"
        >I Agree</app-button
        >
      </app-button-container>
      <br />
    </div>
  }
